export class Pagination {
	date?: string;
	dates?: [any];
	
	items: string[] = [];
	page: number = 0;
	skip?: number;

	getDate(): string {
		return this.items[this.page - 1];
	}
	
	get pageCount() {
		return this.items.length;
	}
	
	
	get pages() {
		return this.items;
	}
	
	
	static getNew(data: object): Pagination {
		const p = new Pagination();
		
		Object.getOwnPropertyNames(p).forEach(key => {
			if (typeof data[key] !== 'undefined') {
				p[key] = data[key];
			}
		});
		
		return p;
	}
	
	
	fill(data: object) {
		Object.getOwnPropertyNames(this).forEach(key => {
			if (typeof data[key] !== 'undefined') {
				this[key] = data[key];
			}
		});
	}
}
